import { render, staticRenderFns } from "./ProductionSettings.vue?vue&type=template&id=52e844e4&scoped=true&"
import script from "./ProductionSettings.vue?vue&type=script&lang=js&"
export * from "./ProductionSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProductionSettings.vue?vue&type=style&index=0&id=52e844e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e844e4",
  null
  
)

export default component.exports